module.exports = __webpack_public_path__ + "img/times.94aaca8b.svg";